/**
 * Overlay Color Fix - ULTRA AGGRESSIVE VERSION
 * Forces white overlay using every possible method
 */

(function() {
  'use strict';

  console.log('🎯 OVERLAY FIX V3 - LOADING...');

  const WHITE_OVERLAY = 'rgba(255, 255, 255, 0.3)';

  /**
   * Apply white color using EVERY method possible
   */
  function ultraForceWhite() {
    console.log('🔧 Running ultraForceWhite...');
    let fixedCount = 0;

    // METHOD 1: Find ANY element with "overlay" in the class name
    const allElements = document.querySelectorAll('*');
    allElements.forEach(function(el) {
      const className = (el.className || '').toString();

      // If class contains both "overlay" AND "background" (case insensitive)
      if ((className.toLowerCase().indexOf('overlay') !== -1) &&
          (className.toLowerCase().indexOf('background') !== -1)) {

        console.log('🎯 FOUND OVERLAY ELEMENT:', className);

        // Apply in EVERY way possible
        el.style.backgroundColor = WHITE_OVERLAY;
        el.style.setProperty('background-color', WHITE_OVERLAY, 'important');

        // Nuclear option: completely replace the style attribute
        const currentStyle = el.getAttribute('style') || '';
        el.setAttribute('style', currentStyle + '; background-color: ' + WHITE_OVERLAY + ' !important;');

        fixedCount++;
        console.log('✅ APPLIED WHITE TO:', el);
      }
    });

    // METHOD 2: Override the CSS variable EVERYWHERE
    document.documentElement.style.setProperty('--forms-overlay-background-color', WHITE_OVERLAY, 'important');
    document.body.style.setProperty('--forms-overlay-background-color', WHITE_OVERLAY, 'important');

    // METHOD 3: Inject a style tag with ULTRA high specificity
    let styleTag = document.getElementById('ultra-overlay-fix');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'ultra-overlay-fix';
      styleTag.textContent = `
        /* ULTRA OVERLAY FIX */
        [class*="overlay"][class*="Background"],
        [class*="overlay"][class*="background"],
        [class*="Overlay"][class*="Background"],
        div[class*="overlay"] div,
        div[class*="Overlay"] div {
          background-color: ${WHITE_OVERLAY} !important;
        }

        :root, * {
          --forms-overlay-background-color: ${WHITE_OVERLAY} !important;
        }
      `;
      document.head.appendChild(styleTag);
      console.log('📝 Style tag injected');
    }

    console.log(`✅ Fixed ${fixedCount} overlay elements`);
    return fixedCount;
  }

  /**
   * Start monitoring
   */
  function startUltraMonitoring() {
    console.log('👀 Starting ULTRA monitoring...');

    // Run immediately and repeatedly
    ultraForceWhite();
    setTimeout(ultraForceWhite, 10);
    setTimeout(ultraForceWhite, 50);
    setTimeout(ultraForceWhite, 100);
    setTimeout(ultraForceWhite, 250);
    setTimeout(ultraForceWhite, 500);
    setTimeout(ultraForceWhite, 1000);
    setTimeout(ultraForceWhite, 2000);

    // Watch for ANY DOM changes
    const observer = new MutationObserver(function() {
      console.log('🔄 DOM CHANGED - Re-applying fix...');
      ultraForceWhite();
      setTimeout(ultraForceWhite, 50);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    console.log('✅ OBSERVER ACTIVE');
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startUltraMonitoring);
  } else {
    startUltraMonitoring();
  }

  window.addEventListener('load', function() {
    console.log('🔄 Window loaded - re-applying...');
    setTimeout(ultraForceWhite, 100);
    setTimeout(ultraForceWhite, 500);
  });

  // Expose for manual debugging
  window.ultraForceWhite = ultraForceWhite;
  console.log('💡 TIP: Run window.ultraForceWhite() in console to manually trigger');

})();
